export const MODIFIERS_SET = 'character.MODIFIERS_SET';
export const MODIFIERS_SET_COMMIT = 'character.MODIFIERS_SET_COMMIT';
